import { render, staticRenderFns } from "./PhotoReview.vue?vue&type=template&id=3d9314e0&"
import script from "./PhotoReview.vue?vue&type=script&lang=js&"
export * from "./PhotoReview.vue?vue&type=script&lang=js&"
import style0 from "./PhotoReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports